import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IsFavoriteComponent } from '@app/entities/images/components/is-favorite/is-favorite.component';
import { ImagePreview } from '@app/entities/images/interfaces/image-preview';
import { AuthSelectors } from '@app/store';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-gallery-item',
  templateUrl: './gallery-item.component.html',
  styleUrls: ['./gallery-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, IsFavoriteComponent, AsyncPipe],
})
export class GalleryItemComponent {
  constructor(private store: Store) {}

  @Input({ required: true })
  galleryItem!: ImagePreview;

  @Input()
  more?: number;

  protected isAuthenticated$: Observable<boolean> = this.store.select(
    AuthSelectors.isAuthenticated,
  );
}
